import { useAppSelector } from "store";

const BusinessInfo = () => {
  const profileInfo = useAppSelector((state) => state.cabinet);

  return (
    <div className="business-info-container">
      <div className="business-info-row">
        <div className="business-info-field">Company name</div>
        <div className="business-info-value">{profileInfo.companyName}</div>
      </div>
      <div className="business-info-row">
        <div className="business-info-field">Country</div>
        <div className="business-info-value">{profileInfo.country}</div>
      </div>
      <div className="business-info-row">
        <div className="business-info-field">
          Position of responsible person
        </div>
        <div className="business-info-value">{profileInfo.position}</div>
      </div>
    </div>
  );
};

export default BusinessInfo;
